import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Avatar, HStack, Icon, MenuItem, Text } from '@chakra-ui/react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
function UserMenuItem(param) {
    var label = param.label, avatar = param.avatar, onClick = param.onClick, active = param.active;
    return /*#__PURE__*/ _jsx(MenuItem, {
        backgroundColor: active ? 'backgroundActive' : 'transparent',
        color: active ? 'textActive' : 'textPrimary',
        _hover: {
            textDecoration: 'none',
            bgColor: active ? 'backgroundAccent' : 'backgroundHover'
        },
        onClick: onClick,
        icon: /*#__PURE__*/ _jsx(Avatar, {
            size: "xs",
            src: avatar
        }),
        children: /*#__PURE__*/ _jsxs(HStack, {
            spacing: 2,
            justifyContent: "space-between",
            width: "100%",
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    children: label
                }),
                active ? /*#__PURE__*/ _jsx(Icon, {
                    as: FontAwesomeIcon,
                    icon: faCheck
                }) : null
            ]
        })
    });
}
export default UserMenuItem;
